/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import { NumericFormat } from "react-number-format";

import { Field } from "formik";
import { FormControl, FormLabel, Box, FormErrorMessage } from "@chakra-ui/react";

import "./style.scss";

const CurrencyInputAlternate = ({
  inputName,
  labelName,
  input,
  setInput,
  center,
  readOnly,
  removeBorder,
  inputRef,
  onBlur,
  allowNegative = false,
  diff = false,
  prefix = "R$ ",
  suffix,
  onFocus,
}) => {
  const myInputRef = useRef(null);

  const clearFormatting = (val) => {
    let inputValue = parseFloat(val.replace("R$ ", "").replaceAll(".", "").replaceAll(",", "."));

    if (isNaN(inputValue)) inputValue = 0;

    return inputValue;
  };

  function handleFocusOnLastIndex(e) {
    if (onFocus && typeof onFocus == "function") onFocus(e);

    const length = myInputRef.current.value.length;
    if (myInputRef.current.setSelectionRange) {
      myInputRef.current.setSelectionRange(length, length);
    }
  }

  const handleKeyDown = (e) => {
    const val = myInputRef.current.value;

    let { key, keyCode } = e;

    if (keyCode == 229) {
      e.preventDefault();

      let newVal = clearFormatting(val);
      newVal = -newVal;
      setInput(newVal);

      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    }

    if (!isNaN(parseInt(key))) {
      e.preventDefault();

      const newVal = clearFormatting(val);

      let [inteiro, decimal] = String(newVal).split(".");
      const isNegative = newVal < 0;
      inteiro = String(inteiro).replace("-", "");

      const firstOfDecimal = decimal?.[0] || 0;
      inteiro += firstOfDecimal;

      decimal = (decimal?.[1] || 0) + key;

      const parsedValue = parseFloat(`${isNegative ? "-" : ""}${inteiro}.${decimal}`);

      setInput(parsedValue);

      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    }
  };

  return (
    <>
      <Field name={inputName}>
        {({ field, meta }) => (
          <FormControl isInvalid={meta.error && meta.touched}>
            {labelName && <FormLabel className="field__label">{labelName}</FormLabel>}
            <Box position="relative">
              <NumericFormat
                className={`currency-input-alternate search-wrapper searchWrapper currencyInput text-[1rem] ${
                  center && "text-center"
                } ${removeBorder && "remove-border"}`}
                prefix={prefix}
                suffix={suffix}
                decimalScale={2}
                decimalSeparator=","
                thousandSeparator="."
                fixedDecimalScale
                allowNegative={allowNegative}
                onFocus={handleFocusOnLastIndex}
                select
                {...field}
                defaultValue={input}
                value={input}
                onKeyDown={handleKeyDown}
                onChange={(e) => {
                  const inputValue = clearFormatting(e.target.value);
                  setInput(inputValue);
                }}
                readOnly={readOnly}
                getInputRef={myInputRef}
                ref={inputRef}
                onBlur={onBlur}
                data-test-id="input-percentage-discount"
              />
            </Box>
            {meta.touched && meta.error && <FormErrorMessage>{meta.error}</FormErrorMessage>}
          </FormControl>
        )}
      </Field>
    </>
  );
};

export default CurrencyInputAlternate;
